import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#1AE9B0",
        secondary: "#747EE0",
        background: "#F6F8FB",
        content: "#2F4858",
        hint: "#9E9E9E"
      }
    },
    options: {
      customProperties: true
    }
  }
});
